export function getPathFromUrl(url: string): string {
  return url.split(/[?#]/)[0]
}

export function unlocalize(relativePath: string, locale: string): string {
  if (isAbsoluteUrl(relativePath)) {
    throw RangeError(`Expecting ${relativePath} to be a relative path`)
  }

  const path = new URL(relativePath, 'https://domain').pathname

  if (path.startsWith(`/${locale}`)) {
    return path.slice(`/${locale}`.length)
  }

  return path
}

export function isAbsoluteUrl(route: string): boolean {
  return new RegExp('^(?:[a-z]+:)?//', 'i').test(route)
}

export function parseUrl(urlString: string): URL {
  if (urlString.startsWith('//')) {
    urlString = `https:${urlString}`
  }
  return new URL(urlString)
}

export function addQueryParamsToURL(url: string, queryParams: Record<string, string | number | boolean>) {
  // parse the URL to separate the base URL and query parameters
  const [baseUrl, queryString] = url.split('?')

  // if there were query parameters in the original URL, parse them into the object
  const queryObj: Record<string, string | number | boolean> = {}
  if (queryString) {
    queryString.split('&').forEach(param => {
      const [key, value] = param.split('=')
      queryObj[key] = decodeURIComponent(value)
    })
  }

  // merge the existing and new query parameters
  const updatedQueryParams = {...queryObj, ...queryParams}

  // construct the updated query string
  const updatedQueryString = Object.entries(updatedQueryParams)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`)
    .join('&')

  // combine the base URL and updated query string to form the new URL
  return `${baseUrl}${updatedQueryString ? `?${updatedQueryString}` : ''}`
}
